import { observer } from 'mobx-react-lite';
import React from 'react';
import styles from '../program-sheet.module.scss';

import ImageFilled from '@smart-tv/components/image-filled/image-filled';
import Typography from '@smart-tv/components/typography';
import testIds from '@smart-tv/e2e/shared/variables';

import { rootStore } from '../_stores/store-root';

export const ProgramSheetContentProviders = observer(() => {
  const { supplierLogo } = rootStore.sheetStore;

  if (supplierLogo.length === 0) {
    return null;
  }

  return (
    <div data-testid={testIds.programsheet.content.actors} className={styles['sheet-description-extended__providers']}>
      <Typography variant="caption" color="textSecondary" gutterBottom={2}>
        Leveres af:
      </Typography>
      <ImageFilled src={supplierLogo} width={60} height={45} borderRadius={1} />
    </div>
  );
});

export default ProgramSheetContentProviders;
